export default class SearchUI {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.searchBar = document.querySelector('.search-container--header');
            this.quicklinks = document.querySelector('.search-suggested__container');
            this.form = this.searchBar.querySelector('.search-form');
            this.input = this.searchBar.querySelector('.search-field');
            this.button = this.searchBar.querySelector('.search-submit');
            this.opener = document.querySelector('.js-search-open');
            this.closer = document.querySelector('.js-search-close');

            this.initListeners();
        });
    }

    initListeners() {
        this.opener.addEventListener('click', (event) => {
            event.preventDefault();
            this.openSearch();
        });

        this.closer.addEventListener('click', (event) => {
            event.preventDefault();
            this.closeSearch();
        });

        const submitters = document.querySelectorAll('[data-submits]');
        submitters.forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                const { submits } = event.target.dataset;
                const theForm = document.getElementById(submits);
                theForm.submit();
            });
        });
    }

    show(el) {
        el.removeAttribute('hidden');
        el.setAttribute('aria-hidden', 'false');
        el.classList.remove('hide');
        setTimeout(() => {
            el.classList.add('animate-in');
        }, 1);
    }

    hide(el) {
        el.classList.remove('animate-in');
        setTimeout(() => {
            el.classList.add('hide');
            el.setAttribute('hidden', 'true');
            el.setAttribute('aria-hidden', 'true');
        }, 200);
    }

    openSearch() {
        setTimeout(() => {
            this.show(this.quicklinks);
            this.input.focus();
            this.hide(this.opener);
        }, 750);
        this.show(this.searchBar);
    }

    closeSearch() {
        this.hide(this.searchBar);
        this.hide(this.quicklinks);
        this.show(this.opener);
        this.opener.focus();
    }
}
